import { api } from '@core/api/apiClient';

export async function unsubscribeUser(token: string, restaurantId: number): Promise<void> {
  await api.post('/api/rest/v2/users/unsubscribe', { token, restaurantId });
}
